export default "__VITE_ASSET__eco1LOOG__"